export default __webpack_public_path__ + "static/media/amex.612d3705.svg";